exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choose[data-v-23f09916]{display:inline-block;vertical-align:middle;margin:0;padding:0;line-height:32px}.c[data-v-23f09916]{border:1px solid #d9e0e6;display:block;width:24px;height:24px;line-height:23px;border-radius:50%;margin-top:4px;margin-right:15px;cursor:pointer;position:relative;color:rgba(72,72,72,.5);text-align:center;float:left}.now[data-v-23f09916]:before{position:absolute;content:\"&radic;\";top:0;left:5px;color:#fff;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-23f09916","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chooseColor.vue
// module id = hhCv
// module chunks = 0